import { createContext, useContext, useEffect, useState } from "react";

const LangContext = createContext({ lang: "pt", setLang: () => {} });

export const TRANSLATIONS = {
  pt: {
    tagline: "Palavras que Atravessam o Tempo",
    hero_subtitle: "Um lugar contemplativo para a leitura, meditação e partilha dos Salmos Bíblicos.",
    search_placeholder: "Pesquisar por número ou palavra...",
    search_short: "Pesquisar...",
    nothing_found: "Nada encontrado.",
    salmo_do_dia: "Salmo do Dia",
    ler_completo: "Ler Salmo Completo",
    por_situacao: "Por Situação",
    encontra_salmo: "Encontra o salmo que te encontra",
    antologia: "Antologia",
    salmos_essenciais: "Salmos em Destaque",
    salmos: "Salmos",
    todos_salmos: "Todos os Salmos",
    sobre: "Sobre",
    inicio: "Início",
    salmo: "Salmo",
    publicidade: "Publicidade",
    reflexao: "Reflexão",
    temas: "Temas",
    ideal_para: "Este salmo é ideal para",
    continua_leitura: "Continua a Leitura",
    salmos_relacionados: "Salmos Relacionados",
    copiar_texto: "Copiar texto",
    copiado: "Copiado",
    copiar_link: "Copiar link",
    link_copiado: "Link Copiado",
    diariamente: "Diariamente",
    receber_diario: "Recebe o Salmo do Dia",
    junta_te: "Junta-te a mais de 1.200 leitores diários que começam a manhã com uma palavra antiga e necessária.",
    subscrever: "Subscrever",
    inscricao_sucesso: "✓ Inscrição realizada. Que a paz te encontre.",
    em_breve: "Em breve",
    todos: "Todos",
    antologia_completa: "Antologia Completa",
    descricao_lista: "Os 150 Salmos — palavras de louvor, lamento, esperança e gratidão.",
    nenhum_salmo: "Nenhum salmo encontrado nesta categoria.",
    salmo_nao_encontrado: "Salmo não encontrado",
    ver_todos: "Ver todos os salmos",
    voltar_inicio: "Voltar ao início",
    nada_pesquisa: "Nada encontrado para",
    sobre_titulo: "salmos.pt",
    sobre_p1: "O salmos.pt nasceu da convicção de que algumas palavras precisam de um lugar próprio. Os Salmos são, há três milénios, o livro de oração mais lido do mundo — e merecem um espaço digno, contemplativo, sem ruído.",
    sobre_p2: "Aqui encontras os Salmos em português, inglês, espanhol e francês — organizados por situação de vida.",
    sobre_p3: "Cada salmo é acompanhado, quando possível, de uma reflexão breve. Não para o explicar — porque os Salmos não precisam de explicação — mas para abrir um pequeno caminho de meditação.",
    sobre_p4: "Que estas palavras te encontrem onde precisas de ser encontrado.",
    footer_tagline: "Palavras que atravessam o tempo. Um lugar contemplativo para a leitura e meditação dos Salmos.",
    footer_navegar: "Navegar",
    footer_reflexao: "Reflexão",
    direitos: "Todos os direitos reservados",
    salmo_destaque: "Destaque",
    descricao_destaques: "Quinze salmos cuidadosamente curados, com reflexão e tags por situação de vida.",
  },
  en: {
    tagline: "Words That Cross Through Time",
    hero_subtitle: "A contemplative place for reading, meditating and sharing the Biblical Psalms.",
    search_placeholder: "Search by number or word...",
    search_short: "Search...",
    nothing_found: "Nothing found.",
    salmo_do_dia: "Psalm of the Day",
    ler_completo: "Read Full Psalm",
    por_situacao: "By Situation",
    encontra_salmo: "Find the psalm that finds you",
    antologia: "Anthology",
    salmos_essenciais: "Featured Psalms",
    salmos: "Psalms",
    todos_salmos: "All Psalms",
    sobre: "About",
    inicio: "Home",
    salmo: "Psalm",
    publicidade: "Advertisement",
    reflexao: "Reflection",
    temas: "Themes",
    ideal_para: "This psalm is ideal for",
    continua_leitura: "Continue Reading",
    salmos_relacionados: "Related Psalms",
    copiar_texto: "Copy text",
    copiado: "Copied",
    copiar_link: "Copy link",
    link_copiado: "Link Copied",
    diariamente: "Daily",
    receber_diario: "Receive the Psalm of the Day",
    junta_te: "Join over 1,200 daily readers who start their morning with ancient, necessary words.",
    subscrever: "Subscribe",
    inscricao_sucesso: "✓ Subscribed. May peace find you.",
    em_breve: "Coming soon",
    todos: "All",
    antologia_completa: "Complete Anthology",
    descricao_lista: "All 150 Psalms — words of praise, lament, hope and gratitude.",
    nenhum_salmo: "No psalms found in this category.",
    salmo_nao_encontrado: "Psalm not found",
    ver_todos: "See all psalms",
    voltar_inicio: "Back to home",
    nada_pesquisa: "Nothing found for",
    sobre_titulo: "salmos.pt",
    sobre_p1: "salmos.pt was born from the conviction that some words need a place of their own. The Psalms have been, for three millennia, the most read prayer book in the world — and they deserve a dignified, contemplative space, free of noise.",
    sobre_p2: "Here you'll find the Psalms in Portuguese, English, Spanish and French — organised by life situation.",
    sobre_p3: "Each psalm is accompanied, where possible, by a brief reflection. Not to explain it — because the Psalms need no explanation — but to open a small path of meditation.",
    sobre_p4: "May these words find you where you need to be found.",
    footer_tagline: "Words that cross through time. A contemplative place for reading and meditating on the Psalms.",
    footer_navegar: "Navigate",
    footer_reflexao: "Reflection",
    direitos: "All rights reserved",
    salmo_destaque: "Featured",
    descricao_destaques: "Fifteen carefully curated psalms with reflection and tags by life situation.",
  },
  es: {
    tagline: "Palabras que Atraviesan el Tiempo",
    hero_subtitle: "Un lugar contemplativo para la lectura, meditación y compartir de los Salmos Bíblicos.",
    search_placeholder: "Buscar por número o palabra...",
    search_short: "Buscar...",
    nothing_found: "Nada encontrado.",
    salmo_do_dia: "Salmo del Día",
    ler_completo: "Leer Salmo Completo",
    por_situacao: "Por Situación",
    encontra_salmo: "Encuentra el salmo que te encuentra",
    antologia: "Antología",
    salmos_essenciais: "Salmos Destacados",
    salmos: "Salmos",
    todos_salmos: "Todos los Salmos",
    sobre: "Sobre",
    inicio: "Inicio",
    salmo: "Salmo",
    publicidade: "Publicidad",
    reflexao: "Reflexión",
    temas: "Temas",
    ideal_para: "Este salmo es ideal para",
    continua_leitura: "Continúa la Lectura",
    salmos_relacionados: "Salmos Relacionados",
    copiar_texto: "Copiar texto",
    copiado: "Copiado",
    copiar_link: "Copiar enlace",
    link_copiado: "Enlace Copiado",
    diariamente: "Diariamente",
    receber_diario: "Recibe el Salmo del Día",
    junta_te: "Únete a más de 1.200 lectores diarios que comienzan la mañana con palabras antiguas y necesarias.",
    subscrever: "Suscribirse",
    inscricao_sucesso: "✓ Suscripción realizada. Que la paz te encuentre.",
    em_breve: "Próximamente",
    todos: "Todos",
    antologia_completa: "Antología Completa",
    descricao_lista: "Los 150 Salmos — palabras de alabanza, lamento, esperanza y gratitud.",
    nenhum_salmo: "Ningún salmo encontrado en esta categoría.",
    salmo_nao_encontrado: "Salmo no encontrado",
    ver_todos: "Ver todos los salmos",
    voltar_inicio: "Volver al inicio",
    nada_pesquisa: "Nada encontrado para",
    sobre_titulo: "salmos.pt",
    sobre_p1: "salmos.pt nació de la convicción de que algunas palabras necesitan un lugar propio. Los Salmos son, desde hace tres milenios, el libro de oración más leído del mundo — y merecen un espacio digno, contemplativo, sin ruido.",
    sobre_p2: "Aquí encontrarás los Salmos en portugués, inglés, español y francés — organizados por situación de vida.",
    sobre_p3: "Cada salmo va acompañado, cuando es posible, de una breve reflexión. No para explicarlo — porque los Salmos no necesitan explicación — sino para abrir un pequeño camino de meditación.",
    sobre_p4: "Que estas palabras te encuentren donde necesitas ser encontrado.",
    footer_tagline: "Palabras que atraviesan el tiempo. Un lugar contemplativo para la lectura y meditación de los Salmos.",
    footer_navegar: "Navegar",
    footer_reflexao: "Reflexión",
    direitos: "Todos los derechos reservados",
    salmo_destaque: "Destacado",
    descricao_destaques: "Quince salmos cuidadosamente seleccionados, con reflexión y etiquetas por situación de vida.",
  },
  fr: {
    tagline: "Des Mots Qui Traversent le Temps",
    hero_subtitle: "Un lieu contemplatif pour la lecture, la méditation et le partage des Psaumes Bibliques.",
    search_placeholder: "Rechercher par numéro ou mot...",
    search_short: "Rechercher...",
    nothing_found: "Rien trouvé.",
    salmo_do_dia: "Psaume du Jour",
    ler_completo: "Lire le Psaume",
    por_situacao: "Par Situation",
    encontra_salmo: "Trouve le psaume qui te trouve",
    antologia: "Anthologie",
    salmos_essenciais: "Psaumes en Vedette",
    salmos: "Psaumes",
    todos_salmos: "Tous les Psaumes",
    sobre: "À propos",
    inicio: "Accueil",
    salmo: "Psaume",
    publicidade: "Publicité",
    reflexao: "Réflexion",
    temas: "Thèmes",
    ideal_para: "Ce psaume est idéal pour",
    continua_leitura: "Continue la Lecture",
    salmos_relacionados: "Psaumes Liés",
    copiar_texto: "Copier le texte",
    copiado: "Copié",
    copiar_link: "Copier le lien",
    link_copiado: "Lien Copié",
    diariamente: "Quotidien",
    receber_diario: "Reçois le Psaume du Jour",
    junta_te: "Rejoins plus de 1 200 lecteurs quotidiens qui commencent la matinée avec des mots anciens et nécessaires.",
    subscrever: "S'abonner",
    inscricao_sucesso: "✓ Inscription réalisée. Que la paix te trouve.",
    em_breve: "Bientôt",
    todos: "Tous",
    antologia_completa: "Anthologie Complète",
    descricao_lista: "Les 150 Psaumes — paroles de louange, de lamentation, d'espérance et de gratitude.",
    nenhum_salmo: "Aucun psaume trouvé dans cette catégorie.",
    salmo_nao_encontrado: "Psaume non trouvé",
    ver_todos: "Voir tous les psaumes",
    voltar_inicio: "Retour à l'accueil",
    nada_pesquisa: "Rien trouvé pour",
    sobre_titulo: "salmos.pt",
    sobre_p1: "salmos.pt est né de la conviction que certaines paroles ont besoin d'un lieu qui leur soit propre. Les Psaumes sont, depuis trois millénaires, le livre de prière le plus lu au monde — et méritent un espace digne, contemplatif, sans bruit.",
    sobre_p2: "Tu trouveras ici les Psaumes en portugais, anglais, espagnol et français — organisés par situation de vie.",
    sobre_p3: "Chaque psaume est accompagné, lorsque cela est possible, d'une brève réflexion. Non pour l'expliquer — car les Psaumes n'ont pas besoin d'explication — mais pour ouvrir un petit chemin de méditation.",
    sobre_p4: "Que ces paroles te trouvent là où tu as besoin d'être trouvé.",
    footer_tagline: "Des mots qui traversent le temps. Un lieu contemplatif pour la lecture et la méditation des Psaumes.",
    footer_navegar: "Naviguer",
    footer_reflexao: "Réflexion",
    direitos: "Tous droits réservés",
    salmo_destaque: "En vedette",
    descricao_destaques: "Quinze psaumes soigneusement choisis, avec réflexion et étiquettes par situation de vie.",
  },
};

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "pt";
    const saved = localStorage.getItem("salmos-lang");
    if (saved && TRANSLATIONS[saved]) return saved;
    const nav = (navigator.language || "pt").slice(0, 2).toLowerCase();
    return TRANSLATIONS[nav] ? nav : "pt";
  });

  const setLang = (l) => {
    setLangState(l);
    try { localStorage.setItem("salmos-lang", l); } catch {}
  };

  useEffect(() => {
    if (typeof document !== "undefined") document.documentElement.lang = lang;
  }, [lang]);

  return <LangContext.Provider value={{ lang, setLang }}>{children}</LangContext.Provider>;
}

export function useLang() {
  const ctx = useContext(LangContext);
  const t = TRANSLATIONS[ctx.lang] || TRANSLATIONS.pt;
  return { ...ctx, t };
}
